import { makeStyles, tokens } from "@fluentui/react-components";
import { ellipsis } from "@/common/style/commonStyle";

export const useStyle = makeStyles({
	// Two compact lines fit inside the 54px supervisor table row without relaxing it (same trick as
	// StatusCell). History rows are content-sized, so they simply grow.
	root: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		// Each line carries its own tooltip, so it is sized by the tag it names rather than stretched to
		// the width of the cell. A stretched trigger puts the tooltip in the middle of the column instead
		// of on the tag, and promises one over the empty space beside a short name.
		alignItems: "flex-start",
		minWidth: 0,
		rowGap: "2px",
	},
	// The whole named line is the tooltip trigger, so it gets the pointer — matching the neighbouring
	// Skills cell, whose PopoverView trigger carries one.
	line: {
		display: "flex",
		alignItems: "center",
		columnGap: "6px",
		minWidth: 0,
		// Content-sized lines still need a ceiling, or a long name would widen the line past the cell
		// instead of letting the ellipsis below engage.
		maxWidth: "100%",
		fontSize: tokens.fontSizeBase200,
		lineHeight: tokens.lineHeightBase200,
		cursor: "pointer",
	},
	// The overflow line packs the remaining colours tighter than a named line. It is only a container:
	// the individual dots are the triggers, so the pointer is reset here and re-applied per dot rather
	// than promising a tooltip over the gaps between them. Inheriting rather than forcing "default"
	// keeps the gaps honest on the surfaces where the whole row is clickable — the interaction cards.
	dotsLine: {
		columnGap: "4px",
		cursor: "inherit",
	},
	dot: {
		width: "12px",
		height: "12px",
		// There is no global border-box reset in this app, so without this the hairline below would
		// render the dot at 14px.
		boxSizing: "border-box",
		flexShrink: 0,
		borderRadius: "50%",
		// A pale tag on a pale surface would otherwise vanish; the hairline keeps every dot visible.
		border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
	},
	// The tooltip needs a real element to anchor to; the dot itself is styled as a fixed-size circle.
	dotWrapper: {
		display: "inline-flex",
		alignItems: "center",
		cursor: "pointer",
	},
	// Counter for tags past the visible dots. Sits on the same line and must not shrink, so the dots
	// row stays within its cell however many tags a flow assigned.
	overflow: {
		flexShrink: 0,
		marginLeft: "2px",
		color: tokens.colorNeutralForeground3,
		fontSize: tokens.fontSizeBase200,
		lineHeight: tokens.lineHeightBase200,
		cursor: "pointer",
	},
	name: {
		...ellipsis(),
	},
});
